import styled from "@emotion/styled";

export const TabPanel = styled.div`
  width: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ResultPanel = styled.div`
  width: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
